import { useDispatch } from "react-redux";
import { Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";

import { ImCross } from "react-icons/im";

import { passwordValidation, stringSpaceValidation } from "helpers/validations";
import { checkUsernameAvailabilityInLocal, registerUser } from "actions/auth";
import { fetchingDataFromApi } from "actions/loaders";

import GeneratePin from "views/components/auth/GeneratePin";
import useNotification from "hooks/useNotification";

const LocalUserRegister = ({ navigatePage, registrationType }) => {
	const dispatch = useDispatch();
	const { notify } = useNotification();

	const [formData, setFormData] = useState(null);
	const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
	const [isUsernameValid, setIsUsernameValid] = useState(true);
	const [isPasswordValid, setIsPasswordValid] = useState(true);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});

		if (e.target.name === "password") setIsPasswordValid(passwordValidation.test(e.target.value));
		if (e.target.name === "username") setIsUsernameValid(stringSpaceValidation.test(e.target.value));
	};

	const handleSubmit = () => {
		dispatch(fetchingDataFromApi(true));

		registerUser({ ...formData, loginType: registrationType }, registrationType, navigatePage, notify);

		dispatch(fetchingDataFromApi(false));
	};

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="transition-opacity duration-250"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<div className="flex flex-col w-full items-center justify-center space-y-10">
				<div className="flex flex-col w-full lg:w-[70%] items-start justify-start">
					<p className={`font-medium text-dark-blue`}>Give a name to your wallet</p>
					<div className="flex flex-col space-y-1 w-full">
						<input
							className="flex w-full px-3 py-2 rounded-lg border text-dark-blue border-dark-blue focus:outline-none"
							name="username"
							placeholder="Create a username"
							type="text"
							required
							value={formData?.username ? formData.username : ""}
							onChange={async (e) => {
								handleChange(e);
								setIsUsernameAvailable(await checkUsernameAvailabilityInLocal(e.target.value, registrationType));
							}}
						/>
						{!isUsernameAvailable && formData?.username?.length > 1 && (
							<div className="flex items-center space-x-2">
								<ImCross className="text-sm text-candy-red" />
								<p className="text-sm text-candy-red">Already taken</p>
							</div>
						)}
						{!isUsernameValid && formData?.username?.length > 1 && (
							<div className="flex items-start space-x-2">
								<ImCross className="text-sm text-candy-red" />
								<p className="text-sm text-candy-red">Spaces are not allowed</p>
							</div>
						)}
					</div>
				</div>

				<GeneratePin formData={formData} setFormData={setFormData} />

				<div className="flex w-full items-center justify-center">
					<button
						onClick={() => handleSubmit()}
						disabled={
							formData?.username && formData?.password && isUsernameAvailable && isPasswordValid ? false : true
						}
						className="bg-dark-blue smooth hover:text-black hover-border-gray-900 text-gray-100 py-3 px-8 mt-5 border border-transparent rounded-3xl disabled:bg-dark-blue disabled:bg-opacity-10 disabled:text-dark-blue"
					>
						Create
					</button>
				</div>
			</div>
		</Transition>
	);
};

export default LocalUserRegister;
